import { render } from "./dialog-modify-amount.vue?vue&type=template&id=5ba6323c&scoped=true&ts=true"
import script from "./dialog-modify-amount.vue?vue&type=script&lang=ts"
export * from "./dialog-modify-amount.vue?vue&type=script&lang=ts"

import "./dialog-modify-amount.vue?vue&type=style&index=0&id=5ba6323c&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba6323c"]])

export default __exports__